import { Box, FieldWrapper } from '@dixa/lib-shared-habla';

import type { FlowCategoriesT } from 'components/powerFlowShared/helpers/flowVariableHelpers';
import { KnowledgeBaseLinkPreview } from 'components/settings/components/sections/dixaMessenger/views/flow/components/shared/knowledgeBaseLinkPreview';
import { replaceTokensWithTags } from 'fable/tokenInput/utils/replaceTokensWithTags/replaceTokensWithTags';

import styles from './messengerMessagePreview.module.scss';

interface Props {
  variables: FlowCategoriesT;
  text: string;
}

export const MessengerMessagePreview = ({
  text,
  variables,
}: Props): JSX.Element => {
  return (
    <FieldWrapper label="Preview" className={styles.root}>
      <div className={styles.container}>
        {!!text && (
          <Box className={styles.message}>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: replaceTokensWithTags(text, variables),
              }}
            />
          </Box>
        )}

        <KnowledgeBaseLinkPreview text={text} />
      </div>
    </FieldWrapper>
  );
};
